var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 139.283,
    viewBox: "0 0 150 139.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M146.558,51.588H97.306L82.339,6.924a5.424,5.424,0,0,0-10.179,0L57.194,51.588H7.607A5.373,5.373,0,0,0,2.25,56.945a3.937,3.937,0,0,0,.1.9,5.147,5.147,0,0,0,2.243,3.783l40.48,28.526L29.538,135.325a5.372,5.372,0,0,0,1.842,6.027,5.181,5.181,0,0,0,3.013,1.306,6.564,6.564,0,0,0,3.348-1.205L77.25,113.294l39.509,28.158a6.274,6.274,0,0,0,3.348,1.205,4.81,4.81,0,0,0,2.98-1.306,5.307,5.307,0,0,0,1.842-6.027L109.393,90.159l40.145-28.794.971-.837a5.617,5.617,0,0,0,1.741-3.583A5.67,5.67,0,0,0,146.558,51.588Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#674188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillStar);
export default __webpack_public_path__ + "static/media/Fill_Star.9b4e1452c677175a8102dfd2fc47066a.svg";
export { ForwardRef as ReactComponent };